import { useEffect, useRef } from "react";
import { useSetState } from "./useSetState";
export const useSafeSetState = (initialState) => {
    const [state, setState, getState] = useSetState(initialState);
    const mountedRef = useRef(false);
    useEffect(() => {
        mountedRef.current = true;
        return () => {
            mountedRef.current = false;
        };
    }, []);
    const safeSetState = (...args) => mountedRef.current && setState(...args);
    return [state, safeSetState, getState];
};
